// extracted by mini-css-extract-plugin
module.exports = {"base":"StickyLineCta_base__Hq6qW","visible":"StickyLineCta_visible__U2Cps"};